// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/app";
// If you are using v7 or any earlier version of the JS SDK, you should import firebase using namespace import
// import * as firebase from "firebase/app"

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";

import * as firebaseui from "firebaseui";

// TODO: Replace the following with your app's Firebase project configuration
// For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
const firebaseConfig = {
    apiKey: "AIzaSyCgKjl7VLtPlw6eO52w3_WfSByac8MJlQM",
    authDomain: "chord-playground.firebaseapp.com",
    projectId: "chord-playground",
    storageBucket: "chord-playground.appspot.com",
    messagingSenderId: "902396353365",
    appId: "1:902396353365:web:2af601db9a22e22be52ddc",
    measurementId: "G-L39GFDZVX8"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const firestore = firebase.firestore()

export const auth = firebase.auth()
export const ui = new firebaseui.auth.AuthUI(auth)